import {
    initCustomSwiper
} from "../../js/global-scripts";
import {
    fancybox
} from '@fancyapps/fancybox/dist/jquery.fancybox.min';

$('.agro-main__tab-right [data-fancybox]').fancybox({
    toolbar: 'auto',
})

var agroTabSwiper = {
    width: Infinity,
    swiperContainer: '.agro-main__tab-swiper',
    swiperContainerWrap: '.agro-main__tab-swiper .agro-main__tab-swiper-wp',
    swiperContainerSlide: '.agro-main__tab-swiper .agro-main__tab-swiper-el',
    swiperVariable: undefined,
    swiperUpdateTime: undefined,
    swiperSettings: {
        slidesPerView: 'auto',
        speed: 500,
        watchOverflow: true,
        // loop: true,
        navigation: {
            nextEl: '.agro-main__tab-swiper-pagi .agro-main__tab-swiper-next',
            prevEl: '.agro-main__tab-swiper-pagi .agro-main__tab-swiper-prev',
        },
        pagination: {
            el: '.agro-main__tab-swiper-fract ',
            type: 'fraction',
        },
    },
}


// Несколько слайдеров Ассортимента
var agroAssortTabSwiper = [];

$('.agro-assort__tab-swiper').each(function (e) {

    $(this).addClass('number' + e + '');
    $(this).siblings('.agro-assort__tab-swiper-pagi').addClass('number' + e + '');

    agroAssortTabSwiper[e] = {
        width: Infinity,
        swiperContainer: '.agro-assort__tab-swiper.number' + e + '',
        swiperContainerWrap: '.agro-assort__tab-swiper.number' + e + ' .agro-assort__tab-swiper-wp',
        swiperContainerSlide: '.agro-assort__tab-swiper.number' + e + ' .agro-assort__el',
        swiperVariable: undefined,
        swiperUpdateTime: undefined,
        swiperSettings: {
            slidesPerView: 'auto',
            speed: 500,
            watchOverflow: true,
            loop: true,
            navigation: {
                nextEl: '.agro-assort__tab-swiper-pagi.number' + e + ' .agro-assort__tab-swiper-next',
                prevEl: '.agro-assort__tab-swiper-pagi.number' + e + ' .agro-assort__tab-swiper-prev',
            },
        },
    }

    initCustomSwiper(agroAssortTabSwiper[e]);
    $(window).resize(function () {
        initCustomSwiper(agroAssortTabSwiper[e]);
    });

});

// Инициализация верхнего слайдера
initCustomSwiper(agroTabSwiper);
$(window).resize(function () {
    initCustomSwiper(agroTabSwiper);
});

// Переключение врехних табов
$('.agro-main__tab-head a').on('click', function (e) {
    e.preventDefault();
    var tabNum = $(this).data('tab');

    $('.agro-main__tab-head a').removeClass('active');
    $('.agro-main__tab-head a[data-tab=' + tabNum + ']').addClass('active');
    $('.agro-main__tab').hide();
    $('.agro-main__tab[data-tab=' + tabNum + ']').fadeIn(300, function () {
        agroTabSwiper.swiperVariable.update();
    });

});

// Переключение табов ассортимента

$('.agro-assort__tab-main').on('click', function () {
    $(this).parents('.agro-assort__tab-select').toggleClass('select-open');
});

$(document).mouseup(function (e) { // событие клика по веб-документу
    var div = $(".agro-assort__tab-select"); // тут указываем ID элемента
    if (!div.is(e.target) // если клик был не по нашему блоку
        && div.has(e.target).length === 0) { // и не по его дочерним элементам
        div.removeClass('select-open');
    }
});

$('.agro-assort__tab-head a').on('click', function (e) {
    e.preventDefault();
    var tabNum = $(this).data('tab'),
        $this = $(this),
        thisParent = $this.parents('.agro-assort__tab-select');
    thisParent.find('.agro-assort__tab-main p').text($this.text());
    thisParent.removeClass('select-open');

    $('.agro-assort__tab-head a').removeClass('active');
    $('.agro-assort__tab-head a[data-tab=' + tabNum + ']').addClass('active');
    $('.agro-assort__tab').hide();
    $('.agro-assort__tab[data-tab=' + tabNum + ']').fadeIn(300, function () {
        $('.agro-assort__tab-swiper').each(function (e) {
            agroAssortTabSwiper[e].swiperVariable.update();
        });
    });
});

// Переключение бекграунда хиро

if ($('.agro-hero__back').find('img').length > 1) {
    var imgL = 1;

    setInterval(() => {
        if (imgL == $('.agro-hero__back img').length) {
            imgL = 1;
        } else {
            imgL = imgL + 1;
        }
        $('.agro-hero__back img').fadeOut(900);
        $('.agro-hero__back img[data-img=' + imgL + ']').fadeIn(900);
    }, 8000);
}

